import { useImage } from "@hooks/useImage"
import { format } from "date-fns"

const useVideoNormaliser = () => {
  const { getGatsbyImage } = useImage()

  const normaliseVideo = (video?: GatsbyTypes.SanityVideo): NormalisedVideo => ({
    key: video?._key,
    title: video?.title,
    showDescription: video?.showDescription,
    description: video?.description,
    videoUrl: video?.videoUrl,
    poster: getGatsbyImage(video?.poster),
    attributes: {
      duration: video?.attributes?.duration,
      publishedAt: video?.attributes?.publishedAt && format(new Date(video?.attributes?.publishedAt), "dd MMMM yyyy"),
    },
    categories:
      video?.categories?.map(category => ({
        handle: category?.handle?.current,
        title: category?.title,
      })) || [],
  })

  const normaliseVideos = (videos?: GatsbyTypes.SanityVideo[]): NormalisedVideo[] => videos?.map(normaliseVideo) || []

  return { normaliseVideos, normaliseVideo }
}

export default useVideoNormaliser
